// extracted by mini-css-extract-plugin
export default {"link_user_reference":"social-links-Linkify__link_user_reference--2Auh8","external_link":"social-links-Linkify__external_link--3W_2V"};